import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import Radio from 'components/form/Radio';
import CheckboxGroup from 'components/form/CheckboxGroup';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import {UPDATE_PROFILE} from "graphql/lc/profile";
import useSnack  from 'hooks/useSnack';
import {useMutation} from "@apollo/react-hooks";
import extend from 'lodash/extend';

const FormItem = Form.FormItem;
const WHO_HELPED = [
  { label: 'Parent/Guardian', value: 'parents' },
  { label: 'School Counselor', value: 'school_counselor' },
  { label: 'Private College Counselor', value: 'private_counselor' },
  { label: 'Other', value: 'other' },
];

const HighSchoolForm = ({ user, highschool_info, form: { getFieldDecorator, validateFields } }) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      values.highschool_state = values.highschool_state?.value;
      return update({
        variables: {
          id: user.id,
          input: {
            highschool_info: extend(highschool_info, values)
          },
        },
      }).then(
        () => {
          snack.success('Profile saved');
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={4}>
          <Grid item md={8}>
            <Typography className={classes.header} variant="h5">
              High School Info
            </Typography>
            <Form>
              <FormItem>
                {getFieldDecorator('highschool_name', {
                  initialValue: highschool_info?.highschool_name
                })(
                  <Input
                    label="High School Name"
                    placeholder="Enter school name"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('gpa', {
                  initialValue: highschool_info?.gpa
                })(
                  <Input
                    label="High School GPA"
                    hint="Weighted/Unweighted"
                    placeholder="Enter high school GPA"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('sat_score', {
                  initialValue: highschool_info?.sat_score
                })(
                  <Input
                    label="SAT Score"
                    hint="Best Scores: Reading & Writing/Math/Total or N/A"
                    placeholder="Enter SAT score"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('act_score', {
                  initialValue: highschool_info?.act_score
                })(
                  <Input
                    label="ACT Score"
                    hint="Best ACT score or N/A"
                    placeholder="Enter ACT score"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('ap_ib_courses', {
                  initialValue: highschool_info?.ap_ib_courses
                })(
                  <Input
                    multiline
                    label="AP/IB Courses"
                    hint="Please list each of your completed AP and IB courses on a different line."
                    placeholder="Enter AP/IB courses"
                    minRows={3}
                    rows={3}
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('sat_2_tests', {
                  initialValue: highschool_info?.sat_2_tests
                })(
                  <Input
                    multiline
                    label="SAT II Test"
                    hint="List each SAT II test you took on a different line"
                    placeholder="Enter SAT II test results"
                    minRows={3}
                    rows={3}
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('college_acceptances', {
                  initialValue: highschool_info?.college_acceptances
                })(
                  <Input
                    label="College Acceptances"
                    hint="Please list every school acceptance you received"
                    placeholder="Enter college acceptances "
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('college_rejections', {
                  initialValue: highschool_info?.college_rejections
                })(
                  <Input
                    label="College Rejections"
                    hint="Please list every school rejection you received or schools where you were  waitlisted  and ultimately not accepted"
                    placeholder="Enter college rejections"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('who_helped', {
                  initialValue: highschool_info?.who_helped
                })(
                  <CheckboxGroup
                    options={WHO_HELPED}
                    label="Who helped you with your college applications?"
                  />,
                )}
              </FormItem>
            </Form>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent className={classes.footer}>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Save
        </Button>
      </CardContent>
    </Card>
  );
};

export default Form.create()(HighSchoolForm);
